export class PageCriteria {
    pageNo:number = 1;
    pageSize:number = 50;
    sortBy:string = "";
    sortOrder: string = "";
    filterBy:Array<object> = [{}];
}